import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const About = () => {
    return (
        <div className="mt-5 p-5 m-5">
            <h2 className="text-center mt-4">The Leading eLearning Platform for Online Courses</h2>
            <h4 className="text-center">By connecting Bengali students all over the world to the best instructors, MSB Academy is helping individuals reach their goals and pursue their dreams. </h4>

            <p className="mt-5">Online Academy was launched with the purpose of helping you to learn valuable new skills that will help you make the most out of your work environment and keep you updated with the most recent developments in the tech world. Each online course on Online Academy is designed and reviewed by the Online Academy Review Team with special attention given to the quality of the content.</p>

            <p className="mt-5">We have tons of High-Quality Courses in every sector of Education. MSB Academy features classes from leading online course creators who've spent thousands of hours teaching classes that aim to help students advance in their professional lives. We ensure that each of our teachers meets our high standards and truly care about helping their students.</p>


            <Row xs={1} md={3} className="g-4">
                <Col>
                    <Card>
                        <Card.Img variant="top" src="https://learn.g2.com/hubfs/G2CM_FI028_Learn_Article_Images-Hard_Skills_vs._Soft_Skills_Image1_V1a.png" />
                        <Card.Body>
                            <Card.Title>SKILLS</Card.Title>
                            <Card.Text>
                                No skill? No problem. Because we are providing high-quality courses in Bangla. So you can learn anything by taking our course &amp; able to grow your skill.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card>
                        <Card.Img variant="top" src="https://leverageedu.com/blog/wp-content/uploads/2020/04/Self-Learning.png" />
                        <Card.Body>
                            <Card.Title>SELF LEARNING</Card.Title>
                            <Card.Text>
                                It's an online-based platform, so you can learn from anywhere in the world. We expect that you will be able to learn anything just by your self.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card>
                        <Card.Img variant="top" src="https://i0.wp.com/www.differencebetween.com/wp-content/uploads/2016/09/Difference-Between-Awareness-and-Knowledge-2.jpg" />
                        <Card.Body>
                            <Card.Title>KNOWLEDGE</Card.Title>
                            <Card.Text>
                                Get knowledge about online business, trend analysis, customer approaches, graphics design, photography, products marketing &amp; more.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card>
                        <Card.Img variant="top" src="https://img.freepik.com/free-vector/group-therapy-illustration_74855-5516.jpg?size=626&ext=jpg" />
                        <Card.Body>
                            <Card.Title>DISCUSSION</Card.Title>
                            <Card.Text>
                                Prompt conversation and collaboration within your community of learners and instructors in the course forum.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card>
                        <Card.Img variant="top" src="https://www.plastiq.com/wp-content/uploads/2021/06/Blog_InternationalWire_20190820b.png" />
                        <Card.Body>
                            <Card.Title>LOCAL AND INTERNATIONAL PAYMENTS </Card.Title>
                            <Card.Text>
                                You can pay for the course in BDT currency via bKash / Rocket / DBBL / Nexus / Visa Or MasterCard.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card>
                        <Card.Img variant="top" src="https://www.whizlabs.com/blog/wp-content/uploads/2019/12/importance_of_certifications.png" />
                        <Card.Body>
                            <Card.Title>CERTIFICATION</Card.Title>
                            <Card.Text>
                                After completing an online course you'll be awarded an official Verified Online Academy Certificate that you can include in your CVs and Resumes.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default About;